import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import Editmizaniamodal from "./editmizaniamodal";
import deleteaction from "../../context/action/mizania/deleteaction";
import numberbeautify from "../../utils/numberbeautify";

const Mizanialist = () => {
    const { initState, recaller, setrecaller, clear, initDispatch } =
        useContext(GlobalContext);

    const [mizania_id, setmizania_id] = useState();
    const [mizania_statement_number, setmizania_statement_number] = useState('');
    const [mizania_directory_number, setmizania_directory_number] = useState('');
    const [mizania_name, setmizania_name] = useState();
    const [mizania_amount, setmizania_amount] = useState();
    const [mizania_date, setmizania_date] = useState();
    const [mizania_category, setmizania_category] = useState();
    const [show, setshow] = useState(false);
    return (
        <div>
            <Editmizaniamodal
                show={show}
                setshow={setshow}
                mizania_id={mizania_id}
                mizania_statement_number={mizania_statement_number}
                setmizania_statement_number={setmizania_statement_number}
                mizania_directory_number={mizania_directory_number}
                setmizania_directory_number={setmizania_directory_number}
                mizania_name={mizania_name}
                setmizania_name={setmizania_name}
                mizania_amount={mizania_amount}
                setmizania_amount={setmizania_amount}
                mizania_date={mizania_date}
                setmizania_date={setmizania_date}
                mizania_category={mizania_category}
                setmizania_category={setmizania_category}
            />
        
            {/* Category List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                <h2 className="text-base font-semibold text-slate-800">لیستی میزانییە</h2>
                </div>
        
                {/* Table */}
                <table className="w-full">
                <thead>
                    <tr className="bg-slate-50 border-b border-slate-100">
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">رقم الكشف</th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">رقم الدليل</th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">ناو</th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">بڕ</th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">ساڵ</th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">جۆر</th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">کاتیگۆری</th>
                    <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">گۆڕانکاری</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-slate-50">
                    {initState.mizania.map((lis) => (
                    <tr key={lis.mizania_id} className="hover:bg-slate-50 transition-colors duration-100">
                        <td className="px-6 py-4 text-sm font-medium text-slate-500 text-right">
                            {lis.mizania_statement_number}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-500 text-right">
                            {lis.mizania_directory_number}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.mizania_name}
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-500 text-right">
                            {numberbeautify(lis.mizania_amount)}
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-500 text-right">
                            {lis.mizania_date}
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-800 text-right">
                            {lis.mizania_type=="general_budget"?"الميزانية العامة":"كشف العمليات الجارية"}
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-800 text-right">
                            {lis.mizania_category}
                        </td>
                        <td className="px-6 py-4 text-right">
                        <button
                            className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-red-50 text-red-700 hover:bg-red-200 border border-red-400 transition-colors cursor-pointer"
                            onClick={() => {
                                if (
                                  window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") ==
                                  true
                                ) {
                                    deleteaction(lis.mizania_id)(recaller)(setrecaller)(initDispatch)(clear);
                                }
                            }}
                        >
                            ڕەشکردنەوە
                        </button>
                        </td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>
            </div>
    )
}

export default Mizanialist